module.exports = __webpack_public_path__ + "static/media/18.313c54ad.png";